export default function RecentDistributionsReport({
  data,
  page,
  pageSize,
  onPrevious,
  onNext,
  onPageSizeChange,
  onExportCsv,
  exporting,
  loading,
}) {
  const rows = data?.rows || [];
  const totalRows = data?.totalRows || 0;
  const totalPages = data?.totalPages || 1;
  const hasMore = Boolean(data?.hasMore);
  const startRecord = totalRows === 0 ? 0 : (page - 1) * pageSize + 1;
  const endRecord = totalRows === 0 ? 0 : Math.min((page - 1) * pageSize + rows.length, totalRows);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200">
      <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Recent Distributions</h2>
          <p className="text-sm text-gray-600 mt-1">
            Cached, paginated report of recent Distributely assignments.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={onExportCsv}
            disabled={loading || exporting || totalRows === 0}
            className="inline-flex items-center px-2.5 py-1.5 rounded-md border border-gray-300 text-xs text-gray-700 hover:bg-gray-50 disabled:opacity-50"
            title="Export full report to CSV"
          >
            ⭳ Export
          </button>
          <div className="text-sm text-gray-600">
            {startRecord.toLocaleString()}-{endRecord.toLocaleString()} of {totalRows.toLocaleString()} records
          </div>
        </div>
      </div>

      <div className="p-6">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  HS Object Type
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  HS Object ID
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Team Name
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Assignee Name
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Error Name
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {rows.length === 0 ? (
                <tr>
                  <td className="px-4 py-4 text-sm text-gray-500" colSpan={5}>
                    No distributions found for this filter set.
                  </td>
                </tr>
              ) : (
                rows.map((row, idx) => (
                  <tr key={`${row.objectId}-${row.timestamp}-${idx}`} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-900">{row.objectType || '-'}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{row.objectId || '-'}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{row.teamName || '-'}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{row.assigneeName || '-'}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{row.errorName || '-'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="mt-4 flex items-center justify-between">
          <div className="text-sm text-gray-600">
            Page {page} of {totalPages}
          </div>
          <div className="flex items-center gap-3">
            <label className="text-sm text-gray-600">
              Page size
              <select
                value={pageSize}
                onChange={(e) => onPageSizeChange(Number(e.target.value))}
                className="ml-2 px-2 py-1 border border-gray-300 rounded-md"
                disabled={loading}
              >
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </label>
            <button
              onClick={onPrevious}
              disabled={loading || page <= 1}
              className="px-3 py-1.5 rounded-md border border-gray-300 text-sm disabled:opacity-50"
            >
              Previous
            </button>
            <button
              onClick={onNext}
              disabled={loading || !hasMore}
              className="px-3 py-1.5 rounded-md border border-gray-300 text-sm disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
